import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction, loadDataDoneAction, loadDataErrorAction } from 'modules/app/actions';
import { getVisits } from '../actions';
import { VISITS } from '../constants/actionTypes';
import * as api from '../repository';


function *_fetchVisits(action) {
    yield put(loadDataAction('visits'));
    try {
        const visits =  yield call(api.getVisits(action.filters));
        yield put(getVisits.success({visits}));
        yield put(loadDataDoneAction('visits'));
    } catch (error) {
        yield put(getVisits.error(error));
        yield put(loadDataErrorAction('visits', {response: error.response}, action));
    }
}

export function *fetchVisits() {
    yield takeEvery(VISITS.REQUEST, _fetchVisits);
}
